import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ModalAnularAusenciaService } from './modal-anular-ausencia.service';
import { DatabaseService } from '@app/database/database.service';
import { BackgroundSyncService } from '@app/helpers/backgroundSync.service';
import { MessageAlertService } from '@app/shared/views/_messagesService/_messageAlertServices';
import { ConnectionService, ConnectionState } from 'ng-connection-service';
@Component({
  selector: 'app-modal-anular-ausencia',
  templateUrl: './modal-anular-ausencia.component.html',
  styleUrls: ['./modal-anular-ausencia.component.scss']
})
export class ModalAnularAusenciaComponent {
  @Input() nombreTrabajador: string;
  @Input() nombreEstudio: string;
  @Input() numeroEstudio: string;
  @Input() card: any;
  @Output() closeModalAnularAusencia = new EventEmitter<boolean>();
  @Output() asistenciaUpdate = new EventEmitter<any>();
  @Output() refreshList = new EventEmitter<any>();

  private _displayModalAnularAusencia: boolean = false;
  isOnline = true;

  constructor(
    private modalAnularAusenciaService: ModalAnularAusenciaService,
    private databaseService: DatabaseService,
    private backgroundSyncService: BackgroundSyncService,
    private messageAlertServices: MessageAlertService,
    private connectionService: ConnectionService
  ) {}

  ngOnInit(): void {
    this.connectionService.monitor().subscribe((connected: ConnectionState) => {
      this.isOnline = connected.hasNetworkConnection;
    })
    this.isOnline = JSON.parse(localStorage.getItem('isStillOnline'));
  }

  get displayModalAnularAusencia(): boolean {
    return this._displayModalAnularAusencia;
  }

  @Input() set displayModalAnularAusencia(value: boolean) {
    this._displayModalAnularAusencia = value;
  }

  closeModal() {
    this._displayModalAnularAusencia = false;
    this.closeModalAnularAusencia.emit(false);
  }

  private buildRequest() {
    return {
      examenNumero: this.numeroEstudio,
      tipoEstudio: this.nombreEstudio
    };
  }

  submitAnularAusencia() {
    if (this.isOnline) {
      this.saveToOnline();
    } else {
      this.saveToOffline();
    }
  }

  private saveToOnline(): void {
    const dataToSend = this.buildRequest();
    this.modalAnularAusenciaService
      .anularAusencia(dataToSend)
      .subscribe(
        (response) => {
          const tabla = `examenes` + (this.card?.lote?.reevaluacion ? `Reevaluacion` : `Periodicos`);
          
          let examen = this.databaseService.getSingleExamenItem(tabla, +dataToSend.examenNumero);
          examen = this.modifyExamAnularAusencia(examen);
          this.databaseService.editTableItem(+dataToSend.examenNumero, tabla, examen);
          this.databaseService.editTableItem(+dataToSend.examenNumero, tabla + `Filtrados`, examen);
          
          this.messageAlertServices.setMessage(0, {
            severity: 'success',
            detail: 'Ausencia anulada correctamente',
          });
          this.asistenciaUpdate.emit({asistencia:"Anular Ausencia", refreshList: true});
          this.closeModal();
        },
        (error) => {
          this.messageAlertServices.setMessage(0, {
            severity: 'error',
            detail: "Ocurrió un error al anular la ausencia.",
          });
          console.log(error);
        }
      );
  }

  private saveToOffline(): void {
    const dataToSend: any = this.buildRequest();
    dataToSend.table = `examenes` + (this.card?.lote?.reevaluacion ? `Reevaluacion` : `Periodicos`);
    
    this.databaseService
      .setExamenOnPresentismoPorEnviarTable(dataToSend, this.modalAnularAusenciaService.buildUrlApi('estudios/anularAusente'))
      .then((response) => {
        let examen = this.databaseService.getSingleExamenItem(dataToSend.table, +dataToSend.examenNumero);
        examen = this.modifyExamAnularAusencia(examen);
        this.databaseService.editTableItem(+dataToSend.examenNumero, dataToSend.table, examen);
        this.databaseService.editTableItem(+dataToSend.examenNumero, dataToSend.table + `Filtrados`, examen);
        
        this.messageAlertServices.setMessage(0, {
          severity: 'success',
          detail: 'Se anulará la ausencia cuando se retome la conexión.',
        });
        this.asistenciaUpdate.emit({asistencia:"Anular Ausencia"});
        this.closeModal();
      })
      .catch((e) => {
        this.messageAlertServices.setMessage(0, {
          severity: 'error',
          summary: '',
          detail: 'Ha ocurrido un error. Por favor reinitente más tarde y disculpe las molestias ocasionadas',
          key: 'anular-ausencia',
        });
      });
  }

  private modifyExamAnularAusencia(examen: any): any {
    examen.asistencia = null;
    examen.motivoCierre = null;
    return examen;
  }
} 